import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { Grid, Typography } from "@mui/material";
import {
  useEquipment,
  useUser,
  useDetector,
  useAnalysisTypes,
} from "@services/servicesGenericsTables";
import React, { useEffect, useMemo } from "react";
import {
  MEDIO_FILTER_OPTIONS,
  PROCESS_OPTIONS_VALUE,
} from "../../utils/constans";
import { useFormContext } from "react-hook-form";
import { useBackgroundCodes } from "@services/servicesGenericsTables/useBackgroundCodes";

const CommonForm = ({ disable }: { disable: boolean }) => {
  const { equipmentList } = useEquipment();
  const { userList } = useUser();
  const { backgroundCodesList } = useBackgroundCodes();
  const { analysisTypeList } = useAnalysisTypes();

  const { watch, getValues, setValue } = useFormContext();
  const selectedType = watch("type");
  const watchEquipment = watch("equipment");

  useEffect(() => {
    const equipment = watchEquipment;
    setValue("detector", equipment?.codet);
  }, [watchEquipment]);

  const watchFilter = watch("filter");

  const filteredBackgroundCodesList = useMemo(() => {
    const filterByselectedType = backgroundCodesList.filter(
      (item) => item.proceso === selectedType?.value
    );
    if (!watchFilter) return filterByselectedType;

    return filterByselectedType.filter(
      (item) => item.medio_filtro === watchFilter.value
    );
  }, [watchFilter, selectedType]);

  const filteredAnalysisTypeList = analysisTypeList.filter(
    (item) => item.codigo == "IG" || item.codigo == "GT"
  );

  return (
    <>
      <Grid item xs={12} my={3}>
        <Typography variant="tagText">{"Datos Generales"}</Typography>
      </Grid>
      <ResponsiveFormContainer columns={4}>
        {selectedType?.value == PROCESS_OPTIONS_VALUE.GAMMA && (
          <MAutocomplete
            name="analysis_type"
            options={filteredAnalysisTypeList}
            label="Seleccione el tipo de analisis (IG/GT)"
            getOptionLabel={(option) => `${option.descripcion}` || ""}
            multiple={false}
          />
        )}
        {selectedType?.value !== PROCESS_OPTIONS_VALUE.GAMMA && (
          <MAutocomplete
            name="filter"
            options={MEDIO_FILTER_OPTIONS || []}
            label="Seleccione un medio filtro"
            getOptionLabel={(option) => option?.label || ""}
            disabled={disable}
          />
        )}
        {selectedType?.value !== PROCESS_OPTIONS_VALUE.GAMMA && (
          <MAutocomplete
            key={getValues("code")}
            name="code"
            label="Código Fondo"
            placeholder="Código Fondo"
            options={filteredBackgroundCodesList}
            getOptionLabel={(option) =>
              `${option.proceso} - ${option.tipo_codigo}${
                option.medio_filtro ? ` - ${option.medio_filtro}` : ""
              }` || ""
            }
            disabled={disable}
            validation={{
              required: "El Codigo de fondo es requerido",
            }}
          />
        )}
        <MTextField
          name="counting_time"
          label="Tiempo de Contaje (min)"
          placeholder="Tiempo de Contaje (min)"
          fullWidth
          type="number"
          disabled={disable}
          validation={{
            required: "El tiempo de conteo es requerido",
          }}
        />
        <MDatePicker
          name="creation_date"
          pickerType="date"
          label="Fecha de creación"
          validation={{
            required: "La fecha es requerida",
          }}
          disabled={disable}
        />
        <MDatePicker
          name="calculation_date"
          pickerType="date"
          label="Fecha de cálculo"
          disabled={disable}
        />
        <MAutocomplete
          name="equipment"
          options={equipmentList}
          label="Seleccione un Equipo"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}` || ""
          }
          validation={{ required: "El equipo es requerido" }}
          disabled={disable}
        />
        {selectedType?.value !== PROCESS_OPTIONS_VALUE.ALFA &&
          selectedType?.value !== PROCESS_OPTIONS_VALUE.BETA && (
            <MTextField
              name="detector"
              label="Detector"
              placeholder="Detector"
              fullWidth
              disabled
            />
          )}

        {/* 
       <MAutocomplete
          name="instalation"
          options={installationList}
          label="Instalación"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}`
          }
          disabled={disable}
        />
  */}
        <MAutocomplete
          name="analyst"
          options={userList}
          label="Seleccione un analista"
          getOptionLabel={(option) => option.username || ""}
          validation={{ required: "El analista es requerido" }}
        />
        <MTextField
          name="description"
          label="Descripción"
          placeholder="Descripción"
          type="textArea"
          rows={4}
          multiline
          fullWidth
          disabled={disable}
        />
      </ResponsiveFormContainer>
      <Grid item xs={12} my={3}>
        <Typography variant="tagText">{"Cálculos"}</Typography>
      </Grid>
    </>
  );
};

export default CommonForm;
